import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const PageListCheckIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M6 15H1.63637V3.54547H11.8182V5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
    <path
      d="M3.54546 1H14.3636V5.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
    <path
      d="M4.2 6.79999H7.2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.916369"
    />
    <path
      d="M4.2 9.27271H5.9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.906144"
    />
    <path
      d="M4.2 11.8182H5.35"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.846988"
    />
    <path
      d="M11.25 7C13.5972 7 15.5 8.90279 15.5 11.25C15.5 13.5972 13.5972 15.5 11.25 15.5C8.90279 15.5 7 13.5972 7 11.25C7 8.90279 8.90279 7 11.25 7ZM13.3145 9.62793C13.0713 9.40474 12.6929 9.42089 12.4697 9.66406L10.4961 11.8135L9.76465 11.0166L9.7207 10.9736C9.49437 10.7723 9.14789 10.7712 8.91992 10.9805C8.69224 11.1897 8.66365 11.5347 8.84473 11.7773L8.88379 11.8242L10.0566 13.1016C10.1698 13.2248 10.3297 13.2949 10.4971 13.2949C10.6642 13.2948 10.8235 13.2247 10.9365 13.1016L13.3506 10.4717C13.5734 10.2286 13.5573 9.85107 13.3145 9.62793Z"
      fill="#33AB6F"
    />
  </svg>
);
